// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Filter_Bus_filter_card__cxPyS {
    padding: 10px;
}

.Filter_Bus_filter_row__R01e7 {
    display: flex;
    align-items: flex-end;
    gap: 30px;
    flex-wrap: wrap;
}

.Filter_Bus_filter_item__O4SvS {
    flex: 1 1;
    min-width: 220px;
    display: flex;
    flex-direction: column;
}

.Filter_Bus_filter_label__tsjiK {
    font-weight: bold;
    color: #364e69;
    margin-bottom: 5px;
}

.Filter_Bus_vin_reg_row__AmhgZ {
    display: flex;
    gap: 5px;
    width: 100%;
}

.Filter_Bus_filter_dropdown_container__vb-tq {
    position: relative;
    width: -webkit-fill-available; /* fill remaining width */
}

.Filter_Bus_filter_dropdown__p3HnH {
    border-radius: 5px;
    border: none;
    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);
    font-size: 13px;
    padding: 7px;
    width: 100%;
}

.Filter_Bus_filter_dropdown_small__cUVXM {
    border-radius: 5px;
    border: none;
    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);
    font-size: 13px;
    padding: 7px;
    flex: 0 0 100px; /* smaller toggle dropdown */
}

.Filter_Bus_customDateRangePicker__LTc1h {
    font-size: small;
}

.Filter_Bus_filter_buttons__gc5jm {
    display: flex;
    gap: 5px;
    align-items: flex-end;
}

.Filter_Bus_filter_buttons__gc5jm button {
    flex: 1 1;
    min-width: 80px;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Mileagesaarathi_bus/MultivariateAnalysisTab_bus/Filter/Filter_Bus.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,6BAA6B,EAAE,yBAAyB;AAC5D;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,eAAe;IACf,YAAY;IACZ,eAAe,EAAE,4BAA4B;AACjD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,eAAe;AACnB","sourcesContent":[".filter_card {\n    padding: 10px;\n}\n\n.filter_row {\n    display: flex;\n    align-items: flex-end;\n    gap: 30px;\n    flex-wrap: wrap;\n}\n\n.filter_item {\n    flex: 1;\n    min-width: 220px;\n    display: flex;\n    flex-direction: column;\n}\n\n.filter_label {\n    font-weight: bold;\n    color: #364e69;\n    margin-bottom: 5px;\n}\n\n.vin_reg_row {\n    display: flex;\n    gap: 5px;\n    width: 100%;\n}\n\n.filter_dropdown_container {\n    position: relative;\n    width: -webkit-fill-available; /* fill remaining width */\n}\n\n.filter_dropdown {\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);\n    font-size: 13px;\n    padding: 7px;\n    width: 100%;\n}\n\n.filter_dropdown_small {\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);\n    font-size: 13px;\n    padding: 7px;\n    flex: 0 0 100px; /* smaller toggle dropdown */\n}\n\n.customDateRangePicker {\n    font-size: small;\n}\n\n.filter_buttons {\n    display: flex;\n    gap: 5px;\n    align-items: flex-end;\n}\n\n.filter_buttons button {\n    flex: 1;\n    min-width: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter_card": `Filter_Bus_filter_card__cxPyS`,
	"filter_row": `Filter_Bus_filter_row__R01e7`,
	"filter_item": `Filter_Bus_filter_item__O4SvS`,
	"filter_label": `Filter_Bus_filter_label__tsjiK`,
	"vin_reg_row": `Filter_Bus_vin_reg_row__AmhgZ`,
	"filter_dropdown_container": `Filter_Bus_filter_dropdown_container__vb-tq`,
	"filter_dropdown": `Filter_Bus_filter_dropdown__p3HnH`,
	"filter_dropdown_small": `Filter_Bus_filter_dropdown_small__cUVXM`,
	"customDateRangePicker": `Filter_Bus_customDateRangePicker__LTc1h`,
	"filter_buttons": `Filter_Bus_filter_buttons__gc5jm`
};
export default ___CSS_LOADER_EXPORT___;
